import { postApi } from "./api_instance";

export const addBankAccount = async (info, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: "/api/bankAccount/add-account",
      sendToken: true,
      dispatch,
      data: info,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
